import { Injectable } from '@angular/core';
// import { HttpClientModule } from '@angular/common/http';
import { HttpClient, HttpResponse, HttpHeaders, HttpHeaderResponse, HttpParams } from '@angular/common/http';
// import { http } from '@angular/common/http';
import { catchError, map, tap } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { SetHeaderService } from '../services/set-header.service';
// import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import  { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class HttpService {
    headersFormulated: any;

    constructor(
        private http: HttpClient, 

        private auth: AuthService,
        private setheader: SetHeaderService
    ) {
    }

    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'api-secret-key': environment['apiSecretKey'],
            'app-id': environment['appId'],
        })


    };

    httpDocOptions = {
        headers: new HttpHeaders({
            'api-secret-key': environment['apiSecretKey'],
            'app-id': environment['appId'],
        })


    };


    // Set a url
    private Seturl(url: string) {
        return environment['apiv2'] + url;
    }





    // Ask suvendra sir about get request - as for config file without promise it is unable to laod
    // Get request for config file

    getConfigInfo(configUrl: string) {
        return this.http
            .get(configUrl);
        // .pipe(
        //     map((res: HttpResponse<object>) => res)
        // );
    }

    GetRequest(url: string) {
        // console.log(`URL: ${this.Seturl(url)} and Headers: ${JSON.stringify(this.httpOptions)}`);
        url = this.Seturl(url);
        return this.http.get(url, this.httpOptions);
        // .pipe(
        //     map((res: HttpResponse<any>) => res)
        // );

    }

    // Utils here urlObtained: string, inusrerCode: string, queryParamsURL: string

    geUtilsWithQueryParms(url: string, insurerName: string, productName: string, queryParamsURL: string, uuid?: string, proposalId?: any) {


        if (uuid && proposalId) {

            return this.http.get(url + proposalId + '/' + queryParamsURL + '?uuid=' + uuid + '&insurer=' + insurerName + '&product=' + productName, this.httpOptions);
        } else {

            return this.http.get(url + '?insurer=' + insurerName + '&product=' + productName + '&service=' + queryParamsURL, this.httpOptions);
        }

    }




    // Get utils info without insurer

    geUtilsWithoutInsurer(url: string, queryParamsURL: string) {

        return this.http.get(url + '/' + '?service=' + queryParamsURL, this.httpOptions);

    }


    getUtilsWithPrvInfo(url: string, queryParamsURL: string, secondQueryParms: string, secondQueryParamsVal: string | number) {

        // tslint:disable-next-line: max-line-length
        return this.http.get(url + '/' + '?service=' + queryParamsURL + '&' + secondQueryParms + '=' + secondQueryParamsVal, this.httpOptions);
    }


    // get utils with insurer

    // tslint:disable-next-line: max-line-length
    getUtilsWithPrvInfoInusrer(url: string, insurerName: string, productName: string, queryParamsURL: string, secondQueryParms: string, secondQueryParamsVal: string | number) {

        // tslint:disable-next-line: max-line-length
        return this.http.get(url + '/' + '?insurer=' + insurerName + '&product=' + productName + '&service=' + queryParamsURL + '&' + secondQueryParms + '=' + secondQueryParamsVal, this.httpOptions);
    }

    getPincodeForSuitabilityAnalysis(url: string, insurerName: string, productName: string, queryParamsURL: string, secondQueryParms: string, secondQueryParamsVal: string | number) {

        // tslint:disable-next-line: max-line-length
        return this.http.get(url + '/' + '?service=' + queryParamsURL + '&' + secondQueryParms + '=' + secondQueryParamsVal, this.httpOptions);
    }



    // Mimize it -having two get call is not good
    getRequestWithParams(url: string, proposalId: string, uuid: string, queryParamsURL: string) {
        return this.http.get(url + proposalId + '/' + queryParamsURL + '?uuid=' + uuid, this.httpOptions);
    }

    getRequestWithoutParams(url: string, proposalId: string, uuid: string) {
        return this.http.get(url + proposalId + '/' + '?uuid=' + uuid, this.httpOptions);
    }

    postRequestWithoutData(url: string, proposalId: string, uuid: string, queryParamsURL: string) {
        return this.http.post(url + proposalId + '/' + queryParamsURL + '/' + '?uuid=' + uuid, {}, this.httpOptions);
    }

    // Post request with extra params

    postRequestWithExtraParams(url: string, proposalId: string, uuid: string, queryParamsURL: string, extraQueryParms: string) {
        return this.http.post(url + proposalId + '/' + queryParamsURL + '/' + '?uuid=' + uuid + extraQueryParms, {}, this.httpOptions);
    }


    postDataWithProposal(url: string, proposalId: string, uuid: string, queryParamsURL: string, data?: object, extraQuerypaarms?: any) {

        if (extraQuerypaarms) {

            return this.http.post(
                url + proposalId + '/' + queryParamsURL + '/' + '?uuid=' + uuid + extraQuerypaarms, data, this.httpOptions)
                .pipe(map((res: HttpResponse<any>) => res));

        } else {
            return this.http.post(
                url + proposalId + '/' + queryParamsURL + '/' + '?uuid=' + uuid, data, this.httpOptions)
                .pipe(map((res: HttpResponse<any>) => res));
        }

    }




    // Post request with propsoal
    patchRequestWithProposal(url: string, proposalId: string, uuid: string, queryParamsURL: string, data: object) {

        return this.http.patch(url + proposalId + '/' + queryParamsURL + '?uuid=' + uuid, data, this.httpOptions)
            .pipe(map((res: HttpResponse<any>) => res));
    }

    // setToken() {
    //     if (this.httpOptions['headers'].has('Authorization')) {
    //         this.httpOptions['headers'].delete('Authorization');
    //     }


    //     if (this.auth.GetUserToken()) {
    //         this.httpOptions['headers'].set('Authorization', 'Token ' + this.auth.GetUserToken());

    //     } else {
    //         this.httpOptions['headers'].delete('Authorization');

    //     }
    // }

    // Upload document request

    postRequestDocumentData(url: string, proposalId: string, uuid: string, queryParamsURL: string, data: object) {
        return this.http.post(url + proposalId + '/' + queryParamsURL + '/' + '?uuid=' + uuid, data, this.httpDocOptions);
    }

    // tslint:disable-next-line: max-line-length
    deleteRequestuploadData(url: string, proposalId: string, uuid: string, queryParamsURL: string, doc_type: string | number, proof_type: string | number, doc_id: string | number) {
        return this.http.delete(url + proposalId + '/' + queryParamsURL + '/' + '?uuid=' + uuid + '&doc_type=' + doc_type + '&proof_type=' + proof_type + '&doc_id=' + doc_id, this.httpDocOptions);
    }

    // getRequestUploadData(url: string,proposalId: string, uuid: string, queryParamsURL: string, secondQueryParms: string, secondQueryParamsVal: string | number) {
    //     return this.http.get(url + proposalId + '/' + queryParamsURL + '/' + '?uuid=' + uuid + '&' + 'doc_type'+ '=' + secondQueryParms + '&' + 'proof_type' + '=' + secondQueryParamsVal, this.httpOptions);
    // }

    getRequestUploadData(url: string, proposalId: string, uuid: string, queryParamsURL: string) {
        return this.http.get(url + proposalId + '/' + queryParamsURL + '/' + '?uuid=' + uuid, this.httpOptions);
    }




    /********************************************************Revampinng Http services as ********************************************************************************************************* */

    /***
     * Currnelty htto services are being written in a worse way
     * So without affecting the old one implemeting new one and then remove old one in some time
     */


    /**
     * Retrieve header as per product modules
     * Feed Product (Eg: health, motor)
     *
     */

    getHeaderAsProductModule(product: string, isDoc?: boolean) {
        this.headersFormulated = this.setheader.getHeaders(product, isDoc);
        return this.headersFormulated;
    }

    // Invokes HTTP Get Request
    getRequest(url: string, productModules: string ) {

        return this.http.get(url, this.getHeaderAsProductModule(productModules)  );
    }

    // Invokes HTTP Post Request
    postRequest(url: string, productModules: string, dataObtained?: any, isDoc?: boolean  ) {
        const data = dataObtained ? dataObtained : {};
        return this.http.post(url, data, this.getHeaderAsProductModule(productModules, isDoc));
    }

    // Invokes HTTP Put Request
    putRequest( url: string, productModules: string, dataObtained?: any) {
        const data = dataObtained ? dataObtained : {};
        return this.http.put(url, data, this.getHeaderAsProductModule(productModules));
    }

    // Invokes HTTP Patch Request
    patchRequest( url: string, productModules: string, dataObtained?: any, isDoc?: boolean) {
        const data = dataObtained ? dataObtained : {};
        return this.http.patch(url, data, this.getHeaderAsProductModule(productModules, isDoc));
    }

    // Invokes HTTP Delete Request
    deleteRequest( url: string, productModules: string, dataObtained?: any) {
        const data = dataObtained ? dataObtained : {};
        return this.http.put(url, data, this.getHeaderAsProductModule(productModules));
    }


}
